import { EmergencyBannersReduxAction, EmergencyBannersState } from "./types"
import { EMERGENCY_BANNERS_API_STATUS, GET_EMERGENCY_BANNERS } from "./consts"

const initialState: EmergencyBannersState = {
  apiStatus: EMERGENCY_BANNERS_API_STATUS.LOADING,
  emergencyBanners: [],
}

export default function emergencyBannersReducer(
  // eslint-disable-next-line default-param-last
  state: EmergencyBannersState | null | undefined = initialState,
  action: EmergencyBannersReduxAction,
) {
  switch (action.type) {
    case GET_EMERGENCY_BANNERS.GET_EMERGENCY_BANNERS:
      return initialState
    case GET_EMERGENCY_BANNERS.SUCCESS:
      return {
        ...state,
        apiStatus: EMERGENCY_BANNERS_API_STATUS.SUCCESS,
        emergencyBanners: action.res,
      }
    case GET_EMERGENCY_BANNERS.FAILURE:
      return {
        ...state,
        apiStatus: EMERGENCY_BANNERS_API_STATUS.ERROR,
        emergencyBanners: [],
      }
    case GET_EMERGENCY_BANNERS.REQUEST:
    default:
      return state
  }
}
